import React from 'react'
import favicon from '../assets/brand-logo.svg'

const Logo = () => {
  return (<img src={favicon} alt="logo" />);
};


export default Logo